import request from '@/utils/request'
import qs from 'qs'

// 关键件证书列表数据
export const getTableList = params => {
  return request({
    url: '/api/keyPieceCertificate/search',
    method: 'POST',
    data: params
  })
}

// 关键件对应整机证书详情
export const getCertificateDetail = params => {
  return request({
    url: '/api/keyPieceCertific/certificate',
    method: 'POST',
    data:params
  })
}

// 解除关键件对应的整机证书
export const deleteCertificateDetail = params => {
  return request({
    url: '/api/keyPieceCertific/unbind',
    method: 'DELETE',
    data:params
  })
}

// 无证关键件对应整机证书详情
export const getUnlicenseDetail = id => {
  return request({
    url: '/api/keyPieceTest/certificate/' + id,
    method: 'GET',
  })
}

// 解除无证关键件对应的整机证书
export const deleteUnlicenseDetail = (id, testId) => {
  return request({
    url: '/api/keyPieceTest/untie?certificateId=' + id + '&keyPieceTestId=' + testId,
    method: 'POST'
  })
}
// 获取委托人
export const getEntrustName = () => {
  return request({
    url: '/api/keyPieceCertific/entrustName',
    method: 'GET'
  })
}

// 获取制造商名称
export const getManufacturerName = () => {
  return request({
    url: '/api/keyPieceCertific/manufacturerName',
    method: 'GET'
  })
}

// 获取生产厂商名称
export const getfactoryNameList = () => {
  return request({
    url: '/api/keyPieceCertific/factoryName',
    method: 'GET'
  })
}

// 获取制造商名称
export const getManuName = () => {
  return request({
    url: '/api/keyPieceTest/manufacturerName',
    method: 'GET'
  })
}

// 获取生产厂商名称
export const getfactoryName = () => {
  return request({
    url: '/api/keyPieceTest/factoryName',
    method: 'GET'
  })
}
// 获取关键件信息数据 sortBy=product&sortType=asc
export const getkeyData = (id, sortBy, sortType, certModel) => {
  return request({
    url: '/api/certificate/'+ id + '?&sortBy=' + sortBy + '&sortType=' + sortType + '&certModel=' + certModel,
    method: 'GET'
  })
}

// 新增关键件
export const keyPartCreat = params => {
  return request({
    url: '/api/keyPieceCertificate/create',
    method: 'POST',
    data:params
  })
}

// 获取有证关键件
export const getkeyUseDataInfo = (id) => {
  return request({
    url: '/api/keyPieceCertificate/'+ id,
    method: 'GET'
  })
}

// 添加在用型号
export const useModelAdd = params => {
  return request({
    url: '/api/keyPieceCertificate/modelinuse',
    method: 'PUT',
    data: params
  })
}
// 有证关键件的编辑
export const editKeyParts = params => {
  return request({
    url: '/api/keyPieceCertificate',
    method: 'PUT',
    data: params
  })
}
//随整机测试列表
export const getUnLicenseTableList = params => {
  return request({
    url: '/api/keyPieceTest',
    method: 'GET',
    params: params,
    paramsSerializer: params => {
      return qs.stringify(params, {indices: false})
    }
  })
}

// 无证新增关键件
export const keyPartUnlicenseCreat = params => {
  return request({
    url: '/api/keyPieceTest/create',
    method: 'POST',
    data:params
  })
}

// 无证关键件编辑时获取数据
export const getDataInfoUnlicense = (id) => {
  return request({
    url: '/api/keyPieceTest/'+ id,
    method: 'GET'
  })
}
// 编辑关键件
export const keyPartUnlicenseEdit = params => {
  return request({
    url: '/api/keyPieceTest/update',
    method: 'PUT',
    data:params
  })
}
// 获取预览接口
export const showFileUrl = (id) => {
  return request({
    url: '/api/ossConfig/download/'+ id,
    method: 'GET'
  })
}

// 附件上传
export const filesUpload = params => {
  return request({
    url: '/api/addKeyPieceTestFile?id=' + params.id + '&keyPieceTestFile=' + params.keyPieceTestFile,
    method: 'POST',
  })
}

// 删除文件
export const delUpload = params => {
  return request({
    url: '/api/delKeyPieceTestFile?id=' + params.id + '&keyPieceTestFile=' + params.keyPieceTestFile,
    method: 'POST',
  })
}

// 有证关键件附件上传
export const keyFilesUpload = params => {
  return request({
    url: '/api/addKeyPieceCertificateFile?id=' + params.id + '&keyPieceCertificateFile=' + params.keyPieceTestFile,
    method: 'POST',
  })
}

// 有证关键件删除文件
export const keyDelUpload = params => {
  return request({
    url: '/api/delKeyPieceCertificateFile?id=' + params.id + '&keyPieceCertificateFile=' + params.keyPieceTestFile,
    method: 'POST',
  })
}

//获取有证关键件信息
export const getkeyInfo = (number) => {
  return request({
    url: '/api/keyPieceCertificate/number/'+ number,
    method: 'GET'
  })
}
// 替换关键件
export const replaceKeyInfo = params => {
  return request({
    url: '/api/keyPieceCertificate/replace',
    method: 'PUT',
    data:params
  })
}

//型号关联信息
export const getCorrelationInfo = (id) => {
  return request({
    url: '/api/keyPieceCertificate/modelInUse/'+ id,
    method: 'GET'
  })
}
//关联成品信息
export const getCorrelationPart = (id) => {
  return request({
    url: '/api/certificate/search?keyPieceId='+ id,
    method: 'GET'
  })
}

// 型号关联提交
export const putCorrelationData = params => {
  return request({
    url: '/api/certificate/modelInUse',
    method: 'PUT',
    data:params
  })
}

// 关联成品提交
export const putCorrelationPartData = params => {
  return request({
    url: '/api/keyPieceCertificate/related',
    method: 'post',
    data: params
  })
}
//无证关联成品信息
export const getUnCorrelationPart = (id) => {
  return request({
    url: '/api/keyPieceTest/certificate/search?keyPieceId='+ id,
    method: 'GET'
  })
}
//无证关联成品提交
export const putUnCorrelationPartData = params => {
  return request({
    url: '/api/keyPieceTest/related',
    method: 'post',
    data: params
  })
}
// 删除有证关键件（关键件管理）
export const removeKeyPartOld  = (id) => {
  return request({
      url: '/api/keyPieceCertificate/'+ id,
       method: 'DELETE'
     })
}
// 删除无证关键件（关键件管理）
export const removeUnlicenseKeyPartOld  = (id) => {
  return request({
    url: '/api/keyPieceTest/' + id,
    method: 'DELETE'
  })
}
// 删除有证关键件
export const removeKeyPart  = (params) => {
  return request({
    url: '/api/keyPieceCertific/unbind',
    method: 'DELETE',
    data: params
  })
}
export const removeKeyPartModel  = (certificateId, modelInUseId) => {
  return request({
    url: 'api/keyPieceCertificate/model?certificateId='+ certificateId + '&modelInUseId=' + modelInUseId,
    method: 'DELETE'
  })
}
//删除无证关键件
export const removeUnlicenseKeyPart  = (certificateId, keyPieceTestId) => {
  return request({
    url: '/api/keyPieceTest/untie?certificateId='+ certificateId + '&keyPieceTestId=' + keyPieceTestId,
    method: 'POST'
  })
}

//导出关键件清单
export const outputList  = (id, certModel) => {
  return request({
    url: '/api/certificate/keyPieceExport/'+ id + '?certModel=' + certModel,
    method: 'GET',
    responseType: 'blob'
  })
}
//导出关键件清单
export const outputCertList  = (id) => {
  return request({
    url: '/api/keyPieceCertific/certificateExport/'+ id,
    method: 'GET',
    responseType: 'blob'
  })
}
// 获取关键件编辑详情
export const getKeyPartDetailData = (id) => {
  return request({
    url: '/api/keyPieceCertificate/detail/'+ id,
    method: 'GET'
  })
}
// 删除在用型号
export const removeModelinuse  = (id) => {
  return request({
    url: '/api/keyPieceCertificate/modelinuse/'+ id,
    method: 'DELETE'
  })
}
// 已关联在用型号查询
export const getUseModelListData = (keyId, id) => {
  return request({
    url: '/api/keyPieceCertificate/modelInUse/one/'+ keyId + '/'+ id,
    method: 'GET'
  })
}
// 未关联在用型号查询
export const getNoUseModelListData = (keyId, id) => {
  return request({
    url: '/api/keyPieceCertificate/modelInUse/one/reverse/'+ keyId + '/'+ id,
    method: 'GET'
  })
}
// 关键件维护数据添加
export const addSolveData = params => {
  return request({
    url: '/api/certificate/model',
    method: 'post',
    data: params
  })
}
// 关键件维护数据删除
export const removeSolveData  = (id) => {
  return request({
    url: '/api/certificate/model/'+ id,
    method: 'DELETE'
  })
}
// 获取有证编辑详情数据
export const getCertDetailData = (certificateId, keyPieceCertificateId, modelInUseId) => {
  return request({
    url: '/api/certificate/model?certificateId=' + certificateId + '&keyPieceCertificateId='+ keyPieceCertificateId + '&modelInUseId=' + modelInUseId,
    method: 'GET'
  })
}
// 获取随整机编辑详情数据
export const getUnCertDetailData = (certificateId, keyPieceTestId) => {
  return request({
    url: '/api/certificate/model?certificateId=' + certificateId + '&keyPieceTestId='+ keyPieceTestId,
    method: 'GET'
  })
}
// 关键件清单下拉框数据
export const getSolveSelectData = (certificateId) => {
  return request({
    url: '/api/certificate/model?certificateId=' + certificateId,
    method: 'GET'
  })
}
// 导入关键件
export const inputFileData = (id, params) => {
  return request({
    url: '/api/certificate/keyPieceModel/excelImport/' + id,
    method: 'POST',
    responseType: 'blob',
    data: params
  })
}

export const findModuleFile = () => {
  return request({
    url: '/api/static/证书在用型号导入模板.xls',
    method: 'GET',
    responseType: 'blob',
  })
}

